import React from 'react';
import { Icon } from 'antd';
import styles from './Comment.module.scss';

const Files = ({ files }) => {
  const downloadFile = (file, name) => {
    let data = Buffer.from(file, 'base64');
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className={styles.attachedFiles}>
      {files.map((file) => {
        return (
          <div
            key={file.id}
            className={styles.attachedFile}
            onClick={() => downloadFile(file.file, file.name)}
          >
            <div className={styles.attachedFileIcon}>
              <Icon type="paper-clip" />
            </div>
            <div className={styles.fileNameAndSize}>
              <div>{file.name}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Files;
